import CryptoJS from 'crypto-js/crypto-js'
const web_shop_version = require('/version.js')
import { Base64 } from 'js-base64'
import utils from '../tool/utils'
import store from '@/store'

//jiami
export function encryptData(data) {
  const aesKey = store.state.app.aesKey
  var obj = deepCopy(data)
  obj.ts = new Date().getTime()
  //添加前端版本号，用于区分前端请求的版本号
  obj.webVersion = web_shop_version[0]
  if (store.state.app.gameId !== 'webshop-homepage') {
    obj.game_id = store.state.app.gameId
  }
  if (window.__TEST__) {
    const offset = Number(localStorage.getItem('webshop_local_time_offset') || 0)
    if (offset !== 0) {
      obj.locale_t = Math.floor(Date.now() / 1000)
    }
  }

  if (!obj.language_code) {
    //保底一下语言
    obj.language_code = utils.getLang()
  }
  var str = objKeySort(obj)
  let sig = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(str, aesKey))
  sig = Base64.encode(sig)
  obj.auth = sig
  function objKeySort(obj) {
    var newkey = Object.keys(obj).sort()
    var newObj = ''
    for (var i = 0; i < newkey.length; i++) {
      if (newObj == '') {
        newObj = newkey[i] + '=' + obj[newkey[i]]
      } else {
        newObj = newObj + '&' + newkey[i] + '=' + obj[newkey[i]]
      }
    }
    return newObj
  }

  return obj
}

function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  let copy = {}
  if (Array.isArray(obj)) {
    copy = []
  }

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]
      // 过滤掉值为 null 的属性，会影响加密,浏览器会过滤这种字段。
      if (typeof value === 'object' && value === null) {
        continue
      }
      // 过滤掉值为 undefined 的属性，会影响加密,浏览器会过滤这种字段。
      if (value !== undefined) {
        copy[key] = deepCopy(value)
      }
    }
  }
  return copy
}
